module.exports = __webpack_public_path__ + "fonts/Rubik-VariableFont_wght.6d3102fa.ttf";